"use client";
import React from "react";
import { motion } from "framer-motion";

const Shlokas = () => {
  const shlokCard = [
    {
      id: 1,
      heading: "Sita's Devotion",
      text: "नाहं जानामि धर्मं नाधर्मं न च संश्रयम्। यथा रामेण मे प्रीति: तां न जानामि कस्यचित्॥",
      meaning:
        " Sita says she knows no dharma or adharma — her only truth is her love for Rama.",
    },
    {
      id: 2,
      heading: "Rama's Leadership & Justice",
      text: "न त्वहं कामये राज्यं न स्वर्गं न पुनर्भवम्। कामये यत्र रामोऽस्ति तत्र मे स्वस्ति मङ्गलम्॥",
      meaning:
        " The people of Ayodhya declare — “We do not desire kingdom, heaven, or liberation. Our only wish is to be where Rama is, for that alone brings us peace and prosperity.”",
    },
    {
      id: 3,
      heading: "Hanuman's Strength",
      text: "यत्र यत्र रघुनाथकीर्तनं तत्र तत्र कृतमस्तकाञ्जलिम्। भाष्पवारिपरिपूर्णलोचनं मारुतिं नमत राक्षसान्तकम्॥",
      meaning:
        " Wherever Rama's name is sung, Hanuman bows with folded hands, eyes filled with tears of devotion.",
    },
  ];

  return (
    <section className="py-12 px-6 max-w-[1090px] mx-auto">
      {/* Section Heading */}
      <h1 className="text-2xl md:text-4xl font-[Cinzel] text-[#1e3a8a] font-bold text-center mb-10 select-none">
        Sacred Shlokas of the Ramayana
      </h1>

      {/* Shloka Cards */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.2 }}
        className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
      >
        {shlokCard.map(({ id, heading, text, meaning }, index) => (
          <div
            key={id}
            className={`max-w-md mx-auto rounded-xl border border-yellow-700/40 shadow-lg p-6 text-center ${
              index === 1 ? "block" : "hidden md:block"
            }`}
            style={{
              backgroundImage:
                "linear-gradient(180deg, #f7f0d6 0%, #efe3c2 60%, #e6d7ad 100%)",
            }}
          >
            {/* Title */}
            <h2 className="text-sm uppercase tracking-widest text-yellow-800 mb-3">
              {heading}
            </h2>

            {/* Shloka */}
            <p className="text-xl font-bold text-brown-900 mb-4">{text}</p>

            {/* Divider */}
            <div className="h-px bg-gradient-to-r from-transparent via-yellow-700/50 to-transparent mb-4" />

            {/* Meaning */}
            <p className="text-base text-yellow-900">
              <span className="font-semibold">Meaning:</span> {meaning}
            </p>
          </div>
        ))}
      </motion.div>
    </section>
  );
};

export default Shlokas;
